import { useEffect, useState } from "react";
import styled from "styled-components";
import ExploreSearch from "../../../../assets/images/explore-search.svg";
import SelectArrow from "../../../../assets/images/select-arrow.svg";
import SelectedTick from "../../../../assets/images/selected-tick.svg";

// #region STYLED CSS
const StyledComponent = styled.div`
    &.group-selection {
        position: relative;
    }

    &.group-selection.disable {
        opacity: 0.5;
        cursor: not-allowed !important;
    }

    &.group-selection.disable .frame-295922536 {
        cursor: not-allowed !important;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922543 {
        background: #141414;
        border-radius: 43px;
        border-style: solid;
        border-color: #7745e0;
        border-width: 1px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
    }
    .frame-295922536.active {
        border-radius: 43px;
        border-style: solid;
        border-color: #f7665f;
        border-width: 1px;
    }
    .frame-295922536 {
        background: #141414;
        border-radius: 43px;
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 48px;
        position: relative;
        cursor: pointer;
        box-sizing: border-box;
    }
    .frame-1000011150 {
        border-radius: 50px;
        border-style: solid;
        border-color: #f7665f;
        border-width: 1px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }

    .gender-both {
        text-align: center;
        font-family: var(--button-text-large-semibold-font-family, "OpenSans-SemiBold", sans-serif);
        font-size: var(--button-text-large-semibold-font-size, 16px);
        line-height: var (--button-text-large-semibold-line-height, 24px);
        font-weight: var (--button-text-large-semibold-font-weight, 600);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }
    .gender-both-span {
        color: #ffffff;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;

        padding-right: 4px;
    }
    .gender-both-span2 {
        color: #f7665f;
        font-family: "OpenSans-SemiBold", sans-serif;
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
    }
`;

const StyledTypePage = styled.div`
    &.dropdown-mini,
    &.dropdown-mini * {
        box-sizing: border-box;
    }
    &.dropdown-mini {
        background: #212121;
        border-radius: 5.6px;
        padding: 11.2px 5.6px 11.2px 5.6px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 245px;
        position: absolute;
        box-shadow: 0px 0px 14px 0px rgba(17, 22, 32, 1);
        top: 60px;
        z-index: 9;
        //max-height: 288px;
        //overflow: scroll;
    }
    .frame-1000011168 {
        padding: 0px 4px 0px 4px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .search {
        background: var(--surface-surface-tertiary, #212121);
        border-radius: 8px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 38px;
        position: relative;
    }
    .search-sm {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
        overflow: visible;
    }
    .text-label-here {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-size: var(--subtitle-1-font-size, 16px);
        line-height: var(--subtitle-1-line-height, 24px);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        flex: 1;
        width: 147px;
        height: 24px;
        background: transparent;
        border: none;
        outline: none;
    }
    .frame-75 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        overflow: auto;
        //max-height: 227px;
        max-height: 242px;
    }
    .frame-75::-webkit-scrollbar {
        width: 4px;
    }
    .frame-75::-webkit-scrollbar-track {
        background: transparent;
    }
    .frame-75::-webkit-scrollbar-thumb {
        background-color: #3e3e3e;
        border-radius: 50px;
    }
    .frame-313638 {
        display: flex;
        flex-direction: row;
        gap: 11.2px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .all {
        color: var (--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .check {
        flex-shrink: 0;
        width: 17.6px;
        height: 17.6px;
        position: relative;
        overflow: visible;
    }
    .frame-84 {
        border-radius: 5.6px;
        padding: 11.2px;
        display: flex;
        flex-direction: row;
        gap: 11.2px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .frame-84:hover {
        background: var (--surface-surface-tertiary-hover, #282828);
    }
    .frame-313639 {
        display: flex;
        flex-direction: row;
        gap: 11.2px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .b-oimages {
        color: var (--text-text-primary, #ffffff);
        text-align: left;
        font-family: "OpenSans-Regular", sans-serif;
        font-size: 16px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .checkbox {
        height: 17.59px;
        width: 17.59px;
        border: 1px solid rgb(140, 143, 147);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media (max-width: 992px) {
        &.dropdown-mini.mini-type {
            top: 40px;
            left: 10px;
        }
        &.dropdown-mini.mini-brand {
            right: 10px;
            top: 40px;
        }
    }
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #888;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
    }
    .rectangle-5 {
        background: #3e3e3e;
        border-radius: 999px;
        flex-shrink: 0;
        width: 4px;
        height: 51px;
        position: absolute;
        right: 4px;
        top: 50%;
        translate: 0 -50%;
    }
    .frame-3136392 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        height: 30px;
        position: relative;
    }
    .btn-xs-primary {
        background: var(--salmon, #f7665f);
        border-radius: 5px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        cursor: pointer;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-size: var(--button-text-small-font-size, 12px);
        line-height: var(--button-text-small-line-height, 16px);
        font-weight: var(--button-text-small-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;
// #endregion

/** SearchButton component renders a button with a dropdown for selecting options.
 *
 * @param {Object} props - The properties object.
 * @param {string} [props.title="--"] - The title to display on the button.
 * @param {Function} props.onOptionSelected - Callback function when an option is selected.
 * @param {Array} [props.options=[]] - Array of options to display in the dropdown.
 * @param {string} [props.selectedValue=""] - The currently selected value.
 * @param {boolean} props.disabled - Flag to disable the button and dropdown.
 * @param {string} [props.className=""] - Additional classes to add to the component.
 * @param {Object} [props.style={}] - Additional styles to add to the component.
 * @param {boolean} [props.isActive=false] - Flag to indicate if the button is active.
 * @param {boolean} [props.useSearch=false] - Flag to indicate if the button should use a search icon.
 * @param {boolean} [props.isMultiSelect=false] - Flag to indicate if the dropdown should allow multiple selections.
 * @param {Array} [props.selectedValues=[]] - Array of selected values when isMultiSelect is true.
 *
 * @returns {JSX.Element} The rendered SearchButton component.
 */
export default function SearchButton({
    title = "--",
    onOptionSelected,
    options = [],
    selectedValue = "",
    disabled,
    className = "",
    style = {},
    isActive = false,
    useSearch = false,
    isMultiSelect = false,
    selectedValues = []
}) {
    // #region VARS
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [uniqueClassName] = useState(`search-button-${Math.random().toString(36).substring(7)}`);
    // #endregion

    // #region METHODS
    const handleButtonClick = () => {
        if (disabled) return;

        if (!isDropdownOpen) {
            setIsDropdownOpen(!isDropdownOpen);
        }
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        const handleClickOutside = event => {
            if (event.target.closest(`.${uniqueClassName}`) || event.target.closest(".check-img")) return;

            setIsDropdownOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);
    // #endregion

    // #region COMPUTED
    const getSelectedValues = () => {
        if (isMultiSelect) {
            if (selectedValues.length > 2)
                return `${selectedValues[0]?.name}, ${selectedValues[1]?.name} and +${selectedValues.length - 2} more`;
            else return selectedValues.map(v => v?.name).join(", ");
        }
        return selectedValue;
    };

    const onFinishedSelected = selected => {
        setIsDropdownOpen(false);
        onOptionSelected(selected);
    };
    // #endregion

    // #region RENDER
    return (
        <StyledComponent
            className={`group-selection ${uniqueClassName} ${className} ${disabled ? "disable" : ""}`}
            onClick={handleButtonClick}
            style={{ ...style }}>
            <div className={`frame-295922536 ${isActive ? "active" : ""}`}>
                <div className="gender-both">
                    <span>
                        <span className="gender-both-span">{title}:</span>
                        <span className="gender-both-span2">{getSelectedValues()}</span>
                    </span>
                    <img
                        className="chevron-right"
                        src={SelectArrow}
                        alt="chevron-right0.svg"
                        style={{
                            transform: isDropdownOpen && !disabled ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease"
                        }}
                    />
                </div>
            </div>

            {isDropdownOpen && (
                <DropDownComponent
                    selectedType={selectedValue}
                    data={options}
                    onFinishSelected={onFinishedSelected}
                    useSearch={useSearch}
                    isMultiSelect={isMultiSelect}
                    defaultSelectedValues={selectedValues}
                />
            )}
        </StyledComponent>
    );
    // #endregion
}

// #region SUB COMPONENTS
const DropDownComponent = ({
    selectedType,
    data: allOptions,
    onFinishSelected,
    useSearch = false,
    isMultiSelect = false,
    defaultSelectedValues = []
}) => {
    // #region VARS
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState(allOptions);
    const [selectedValues, setSelectedValues] = useState(defaultSelectedValues);
    // #endregion

    // #region METHODS
    const onSearchText = value => {
        setSearchText(value);
    };

    const onItemSelected = item => {
        if (!isMultiSelect) {
            onFinishSelected(item);
            return;
        }

        const itemIsAll = item?.name === "All";
        const allIsSelected = selectedValues?.findIndex(v => v?.name === "All") !== -1;

        if (itemIsAll) {
            if (allIsSelected) setSelectedValues([]);
            else setSelectedValues(allOptions);
            return;
        }

        const removeAll = !itemIsAll && allIsSelected;
        const currentSelected = [...selectedValues.filter(v => (removeAll ? v?.name !== "All" : true))];

        const itemWasSelectedBefore = currentSelected?.findIndex(v => v?.name === item?.name) !== -1;
        if (!itemWasSelectedBefore) setSelectedValues([...currentSelected, item]);
        else setSelectedValues(currentSelected?.filter(v => v?.name !== item?.name));
    };

    const isItemSelected = item => {
        if (!isMultiSelect) {
            return selectedType === item?.name;
        } else return selectedValues?.findIndex(v => v?.name === item?.name) !== -1;
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (searchText === "") {
            setFilteredData(allOptions);
        } else {
            setFilteredData(allOptions.filter(v => v?.name?.toLowerCase()?.includes(searchText?.toLowerCase())));
        }
    }, [searchText, allOptions]);
    // #endregion

    return (
        <StyledTypePage className="dropdown-mini mini-type">
            {useSearch && (
                <div className="frame-1000011168">
                    <div className="search">
                        <img className="search-sm" src={ExploreSearch} alt="search-sm0.svg" />
                        <input
                            type="text"
                            className="text-label-here"
                            placeholder="Search"
                            value={searchText}
                            onChange={e => onSearchText(e.target.value)}
                        />
                    </div>
                </div>
            )}
            <div className="frame-75">
                {filteredData?.map((v, i) => (
                    <div key={i} className="frame-84" onClick={() => onItemSelected(v)}>
                        <div className="frame-313639">
                            <div className="checkbox">
                                {isItemSelected(v) && <img className="check-img" src={SelectedTick} alt="check1.svg" />}
                            </div>
                            <div className="b-oimages">{v?.name}</div>
                        </div>
                    </div>
                ))}
            </div>
            {isMultiSelect && (
                <div className="frame-3136392">
                    <div
                        className="btn-xs-primary"
                        onClick={e => {
                            e.stopPropagation();
                            onFinishSelected(selectedValues);
                        }}>
                        <div className="button">Done</div>
                    </div>
                </div>
            )}
        </StyledTypePage>
    );
};
// #endregion
